module.exports = __webpack_public_path__ + "images/ai-icon.8ad52fcc615a19c147067c15206f840c.png";